import { useToast } from 'vue-toastification'

export const toast = useToast()
